import SubmissionError from '../../../../error/SubmissionError'
import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const create = ({ commit }, values) => {
  commit(types.TERRITORY_CREATE_SET_ERROR, '')
  commit(types.TERRITORY_CREATE_TOGGLE_LOADING)

  return fetch('territories', { method: 'POST', body: JSON.stringify(values) })
    .then((response) => response.json())
    .then((data) => {
      commit(types.TERRITORY_CREATE_TOGGLE_LOADING)
      commit(types.TERRITORY_CREATE_SET_CREATED, data)
    })
    .catch((e) => {
      commit(types.TERRITORY_CREATE_TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.TERRITORY_CREATE_SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        commit(types.TERRITORY_CREATE_SET_ERROR, e.errors._error)
        return
      }

      commit(types.TERRITORY_CREATE_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.TERRITORY_CREATE_RESET)
}
